import { useRef } from "react";
import { useManualModeAccounts } from "../../hooks/api/admin/useManualModeAccounts";
import { WithdrawalContentWrapper } from "./style";
import { ManualAccountsTable } from "./tables/ManualAccountsTable";
import { KillSwitchControls } from "./KillSwitchControls";
import { KillSwitchUsage } from "./KillSwitchUsage";
import { TodayWithdrawals } from "./TodayWithdrawals";
import { COMPONENTS } from "../../constants/design/spacing";
import { MobileDirectory } from "../shared/MobileDirectory";

interface IWithdrawProps {
  isMobile?: boolean;
}

export function Withdraw({ isMobile }: IWithdrawProps) {
  const { data: manualAccountsData = [], isLoading: isManualAccountsLoading } =
    useManualModeAccounts();
  const withdrawalRef = useRef<HTMLDivElement>(null);

  return (
    <>
      {isMobile ? (
        <div ref={withdrawalRef}>
          <MobileDirectory />
        </div>
      ) : undefined}
      <WithdrawalContentWrapper
        isMobile={isMobile}
        style={{
          height: `calc(100dvh - ${
            (isMobile ? COMPONENTS.header.mobile : COMPONENTS.header.main) +
            (withdrawalRef.current?.clientHeight || 0)
          }px)`,
        }}
      >
        <KillSwitchControls />
        <KillSwitchUsage />
        <TodayWithdrawals />
        <ManualAccountsTable
          data={manualAccountsData}
          isLoading={isManualAccountsLoading}
          isMobile={isMobile}
        />
      </WithdrawalContentWrapper>
    </>
  );
}
